// free-tools 转换观测埋点(sendBeacon 上报元数据,不含文件)→ /api/free-tools/event → Analytics Engine。
// 字段与单文件 ToolStagePlaceholder.reportEvent 对齐,供批量(useBatch)复用,让批量转换也进 AE、
// 支持上线后异常聚合分析(不再只存在于 7 天后会被清理的 R2 job.json)。(nuxt#37)
import { useStore } from "vuex";

export function useFreeToolsEvent() {
  const store = useStore();

  // 设备 + 用户元数据(隐私:仅解析后的设备字段、匿名 visitorId、登录时的 userId;不含原始 UA,IP→国家由 Worker 加)。
  function clientMeta() {
    if (!import.meta.client) return {};
    const ua = navigator.userAgent || "";
    const low = ua.toLowerCase();
    const tablet = /ipad|tablet/.test(low) || (/android/.test(low) && !/mobile/.test(low));
    const mobile = /iphone|ipod|windows phone/.test(low) || (/android/.test(low) && /mobile/.test(low));
    let tz = "";
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch (_) {}
    let visitorId = "";
    try {
      visitorId = localStorage.getItem("ft_vid") || "";
      if (!visitorId) {
        visitorId = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : Date.now() + "-" + Math.random().toString(36).slice(2);
        localStorage.setItem("ft_vid", visitorId);
      }
    } catch (_) {}
    const u = (store && store.state && store.state.user) || {};
    const loggedIn = u.token ? 1 : 0;
    const userId = loggedIn && u.userInfo ? String(u.userInfo.user_info_id || "") : "";
    return {
      platform: tablet ? "tablet" : mobile ? "mobile" : "desktop",
      browser: /edg\//i.test(ua) ? "Edge" : /opr\/|opera/i.test(ua) ? "Opera" : /firefox|fxios/i.test(ua) ? "Firefox" : /chrome|crios/i.test(ua) ? "Chrome" : /safari/i.test(ua) ? "Safari" : "Other",
      os: /windows/i.test(ua) ? "Windows" : /iphone|ipad|ipod/i.test(ua) ? "iOS" : /mac os/i.test(ua) ? "macOS" : /android/i.test(ua) ? "Android" : /linux/i.test(ua) ? "Linux" : "Other",
      lang: navigator.language || "",
      tz,
      screenW: (window.screen && window.screen.width) || 0,
      screenH: (window.screen && window.screen.height) || 0,
      dpr: window.devicePixelRatio || 1,
      visitorId,
      loggedIn,
      userId,
    };
  }

  // payload 至少给 { slug, src, tgt, status, mode }，可加 error/inputBytes/outputBytes/durationMs 等。
  function reportEvent(payload) {
    if (!import.meta.client) return;
    try {
      const eventId =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : Date.now() + "-" + Math.random().toString(36).slice(2);
      const body = JSON.stringify({ eventId, ...clientMeta(), ...payload });
      if (navigator.sendBeacon) {
        navigator.sendBeacon("/api/free-tools/event", new Blob([body], { type: "application/json" }));
      } else {
        fetch("/api/free-tools/event", { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
      }
    } catch (_) {
      /* 埋点失败绝不影响转换 UX */
    }
  }

  return { reportEvent, clientMeta };
}
